import React, { useState } from "react";
import InContentAIHeader from "../../ai_tools/shared/InContent/InContentAIHeader";

const InContentAIHeaderDemo = () => {
  const options = ["Ask LitCharts AI", "Discussion Question Generator"];
  const [selected, setSelected] = useState(options[0]);

  return (
    <div className="tw-p-4 tw-bg-gray-tint-95 ask-litcharts-ai--in-content-container tw-h-[300px]">
      <InContentAIHeader
        options={options}
        selectedOption={selected}
        onSelect={() =>
          setSelected((prev) =>
            prev === "Ask LitCharts AI"
              ? "Discussion Question Generator"
              : "Ask LitCharts AI"
          )
        }
      />
    </div>
  );
};

export default InContentAIHeaderDemo;
